import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import css from './SignUpPromoForm.css';
import { FieldTextInput, NamedLink, SecondaryButton } from '../../components';
import { useIntl } from 'react-intl';
import {
  composeValidators,
  emailFormatValid,
  maxLength,
  minLength,
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  required,
  requiredStringNoTrim,
} from '../../util/validators';

const SignUpPromoForm = props => {
  const intl = useIntl();
  const emailRequiredMessage = intl.formatMessage({
    id: 'SignupForm.emailRequired',
  });
  const emailRequired = required(emailRequiredMessage);
  const emailInvalidMessage = intl.formatMessage({
    id: 'SignupForm.emailInvalid',
  });
  const emailValid = emailFormatValid(emailInvalidMessage);

  const passwordMaxLengthMessage = intl.formatMessage(
    {
      id: 'SignupForm.passwordTooLong',
    },
    {
      maxLength: PASSWORD_MAX_LENGTH,
    }
  );
  const passwordRequiredMessage = intl.formatMessage({
    id: 'SignupForm.passwordRequired',
  });
  const passwordMinLengthMessage = intl.formatMessage(
    {
      id: 'SignupForm.passwordTooShort',
    },
    {
      minLength: PASSWORD_MIN_LENGTH,
    }
  );
  const passwordMinLength = minLength(passwordMinLengthMessage, PASSWORD_MIN_LENGTH);
  const passwordMaxLength = maxLength(passwordMaxLengthMessage, PASSWORD_MAX_LENGTH);
  const passwordRequired = requiredStringNoTrim(passwordRequiredMessage);
  const passwordValidators = composeValidators(
    passwordRequired,
    passwordMinLength,
    passwordMaxLength
  );

  return (
    <FinalForm
      {...props}
      render={({ handleSubmit }) => {
        return (
          <div className={css.root}>
            <div className={css.field}>
              <FieldTextInput
                type="email"
                name="email"
                autoComplete="email"
                placeholder={'Your email'}
                label={'Your email'}
                floatingLabel
                validate={composeValidators(emailRequired, emailValid)}
                className={css.input}
                id="email"
              />
            </div>
            <div className={css.field}>
              <FieldTextInput
                className={css.password}
                type="password"
                name="password"
                autoComplete="new-password"
                placeholder={'Password'}
                label={'Password'}
                floatingLabel
                validate={passwordValidators}
                className={css.input}
                id="password"
              />
            </div>
            <SecondaryButton onClick={handleSubmit} className={css.submitBtn}>
              Signup now
            </SecondaryButton>
            {!props.hideTandC && <div className={css.smallText}>
              By signing up, you agree to our{' '}
              <NamedLink className={css.termOfUse} name="TermsOfServicePage">
                T&Cs
              </NamedLink>
              .
              </div>
            }
          </div>
        );
      }}
    />
  );
};

export default SignUpPromoForm;
